import { Directive, Input, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ModalFieldConfig } from '@solcre-org/core-ui';

@Directive({
  selector: '[appBuildFormFromFields]',
  standalone: true,
})
export class BuildFormFromFieldsDirective implements OnInit {
  @Input('appBuildFormFromFields') fields: ModalFieldConfig<any>[] = [];
  @Input() formGroup!: FormGroup;

  ngOnInit(): void {
    if (!this.formGroup) {
      throw new Error('Se requiere [formGroup] para appBuildFormFromFields');
    }

    this.fields.forEach((field) => {
      if (!this.formGroup.get(field.key.toString())) {
        // Si readonly es función, evaluarla pasando el formGroup actual
        const isDisabled =
          typeof field.readonly === 'function'
            ? field.readonly(this.formGroup.value)
            : field.readonly ?? false;

        this.formGroup.addControl(
          field.key.toString(),
          new FormControl<string>(
            { value: '', disabled: isDisabled },
            { validators: field.validators ?? [] }
          )
        );
      }
    });
  }
}
